<template>
  <div class="loyalty-perks-wrapper">
    <ClientOnly>
      <component :is="LoyaltyPerksComponent" v-if="showLoyaltyPerks" />
    </ClientOnly>
  </div>
</template>

<script setup>
/* istanbul ignore file */
import { defineAsyncComponent, watch } from 'vue';
import { useLoyalty } from '~/composables/loyalty/useLoyalty';
import { useEnvProps } from '~/composables/useEnvProps';
import { useProductFlags } from '~/modules/featureControl/composables/useProductFlags';
import useFeatureEligibility from '~/modules/featureControl/composables/useFeatureEligibility';

const { brand } = useEnvProps();
const LoyaltyPerksComponent = defineAsyncComponent(() => import(`./LoyaltyPerks.${brand}.vue`));

const { isUserNonLoyalist } = useLoyalty();
const { isProductPerksEnabledPhase2 } = useFeatureEligibility();
const { isBigTicketItemFlag } = useProductFlags();

const showLoyaltyPerks = ref(false);
watch(
  isUserNonLoyalist,
  (newValue) => {
    showLoyaltyPerks.value = isProductPerksEnabledPhase2 && !isBigTicketItemFlag && !newValue;
  },
  { once: true },
);
</script>

<style lang="scss" scoped>
@import '~settingSCSS';

.loyalty-perks-wrapper {
  &:empty {
    display: none;
    @include margin-bottom-z;
    @include margin-top-z;
  }
}
</style>
